/*
 *   Copyright (c) 2020 
 *   All rights reserved.
 */
import $ from "jquery"
$(function () {
    tabs();
});

let myTimer = null;
const myTimerSpeed = 6 * 1000; // 6 sec
const isResponsiveXS = window.matchMedia("only screen and (max-width: 575.98px)").matches;
const isResponsiveSM = window.matchMedia("only screen and (max-width: 767.98px)").matches;
const isResponsiveMD = window.matchMedia("only screen and (max-width: 1050px)").matches;

const tabs = () => {
    let tabCount = 0, currentIndex = 1;
    const tabContentObj = $(".tab-content");

    tabCount = $("ul.tabs").find("li a").length;
    if (!isResponsiveMD) {
        changeTabIndex();
        myTimer = setInterval(function () {
            changeTabIndex();
        }, myTimerSpeed);

        function changeTabIndex() {
            if (currentIndex > tabCount) {
                currentIndex = 1;
            }
            tabContentObj.hide();
            $("ul.tabs").find("li.selected").removeClass("selected");
            const currentAncorObj = $("ul.tabs").find("li span a").eq(currentIndex - 1);
            currentAncorObj.parent().parent().addClass("selected");

            if (isResponsiveXS || isResponsiveSM || isResponsiveMD) {
                $(".tab-mobile-title").remove();
                $("ul.tabs").parent().prepend($(`<h4 class="tab-mobile-title">${currentAncorObj.text()}</h4>`));
            }

            const currentTab = currentAncorObj.attr("class");
            $(`#${currentTab}`).show("slow");
            currentIndex++;
        };

        $(".tabs li").mouseenter(function () {
            clearInterval(myTimer);
        }).mouseleave(function () {
            myTimer = setInterval(function () {
                changeTabIndex();
            }, myTimerSpeed);
        });
    } else {
        if (isResponsiveXS || isResponsiveSM || isResponsiveMD) {
            $(".tab-mobile-title").remove();
            const firstTab = $("ul.tabs li:first").find("a");
            $("ul.tabs").parent().prepend($(`<h4 class="tab-mobile-title">${firstTab.text()}</h4>`));
            $(`#${firstTab.attr("class")}`).show("slow");
        }
    }

    $(".tabs li").click(function (event) {
        event.preventDefault(); 

        tabContentObj.hide();
        $("ul.tabs").find("li.selected").removeClass("selected");
        const currentAncorObj = $(this).find("a");
        currentIndex = $("ul.tabs").find("li span a").index($(this)) + 1;
        currentAncorObj.parent().parent().addClass("selected");

        const currentTab = currentAncorObj.attr("class");

        if (isResponsiveXS || isResponsiveSM || isResponsiveMD) {
            $(".tab-mobile-title").remove();
            $("ul.tabs").parent().prepend($(`<h4 class="tab-mobile-title">${currentAncorObj.text()}</h4>`));
        }

        $(`#${currentTab}`).show("slow");
        currentIndex++;
    });

    $(".tabs li").keydown(function (event) {
        if(event.keyCode === 13){
            tabContentObj.hide();
            $("ul.tabs").find("li.selected").removeClass("selected");
            const currentAncorObj = $(this).find("a");
            currentIndex = $("ul.tabs").find("li span a").index($(this)) + 1;
            currentAncorObj.parent().parent().addClass("selected");
    
            const currentTab = currentAncorObj.attr("class");
    
            if (isResponsiveXS || isResponsiveSM || isResponsiveMD) {
                $(".tab-mobile-title").remove();
                $("ul.tabs").parent().prepend($(`<h4 class="tab-mobile-title">${currentAncorObj.text()}</h4>`));
            }
    
            $(`#${currentTab}`).show("slow");
            currentIndex++;
        }
    });
}
